import React from 'react';
import classNames from 'classnames';

interface PricingItemListItemProps {
  children: React.ReactNode;
  notAvailable?: boolean;
  noBulletPoint?: boolean;
}

const PricingItemListItem: React.FC<PricingItemListItemProps> = ({
  children,
  notAvailable,
  noBulletPoint
}) => (
  <li
    className={classNames({
      notAvailable,
      noBulletPoint
    })}
  >
    {children}
  </li>
);

export default PricingItemListItem;
